import { call, put, takeLatest } from 'redux-saga/effects';
import { Map } from 'immutable';
import { Notification } from '@utils';
import { postDuplicacao as postDuplicacaoSdk } from '@sdk/Conectores/Duplicacao';

//Action Types
export const Types = {
  POST_DUPLICACAO: 'POST_DUPLICACAO',
  POST_DUPLICACAO_SUCCESS: 'POST_DUPLICACAO_SUCCESS',
  POST_DUPLICACAO_ERROR: 'POST_DUPLICACAO_ERROR',

  RESET: 'RESET',
};

//Action Creators
export const postDuplicacao = (data) => ({ type: Types.POST_DUPLICACAO, data });
export const postDuplicacaoSuccess = (data) => ({ type: Types.POST_DUPLICACAO_SUCCESS, data });
export const postDuplicacaoError = (error) => ({ type: Types.POST_DUPLICACAO_ERROR, error });

export const reset = () => ({ type: Types.RESET });

//saga
function* fetchPostDuplicacao(action) {
  try {
    const data = yield call(postDuplicacaoSdk, action.data);
    yield put(postDuplicacaoSuccess(data));
  } catch (err) {
    Notification.error(err.message);
    yield put(postDuplicacaoError(err));
  }
}

export const saga = [takeLatest(Types.POST_DUPLICACAO, fetchPostDuplicacao)];

// Reducer
const initialState = Map({
  idDuplicado: -1,
  postingDuplicacao: false,
  successPostDuplicacao: false,
  errorPostDuplicacao: false,
});

const handlePostDuplicacao = (state, action) => {
  return state.set('postingDuplicacao', true).set('successPostDuplicacao', false).set('errorPostDuplicacao', false);
};

const handlePostDuplicacaoSuccess = (state, action) => {
  return state
    .set('idDuplicado', action.data.id)
    .set('postingDuplicacao', false)
    .set('successPostDuplicacao', true)
    .set('errorPostDuplicacao', false);
};

const handlePostDuplicacaoError = (state, action) => {
  return state.set('postingDuplicacao', false).set('successPostDuplicacao', false).set('errorPostDuplicacao', action.error);
};

const handleReset = (state, action) => {
  return initialState;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.POST_DUPLICACAO:
      return handlePostDuplicacao(state, action);
    case Types.POST_DUPLICACAO_SUCCESS:
      return handlePostDuplicacaoSuccess(state, action);
    case Types.POST_DUPLICACAO_ERROR:
      return handlePostDuplicacaoError(state, action);

    case Types.RESET:
      return handleReset(state, action);

    default:
      return state;
  }
}
